import i18n from 'i18next'

import { docs } from 'shared/constants/docs'

export const getBrandbookPath = (): string => {
  return i18n.language === 'ka' ? docs.brandbookGeGe : docs.brandbookGeRu
}
